import React from 'react';
import { registerRoutes } from 'foremanReact/routes/RoutingService';

import { addGlobalFill } from 'foremanReact/components/common/Fill/GlobalFill';

import routes from './routes/routes';
import AnsibleHostDetail from './components/AnsibleHostDetail';

import { ANSIBLE_KEY } from './components/AnsibleHostDetail/constants';

addGlobalFill(
  'host-details-page-tabs',
  ANSIBLE_KEY,
  <AnsibleHostDetail key="ansible-host-detail" />,
  500
);

registerRoutes('foreman_ansible', routes);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/global_index.js